import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthActions } from '../../core/auth/store/auth.actions';

// Redirect-only route: it immediately kicks off the OIDC code flow, so it renders
// nothing. Progress during discovery/login is shown by the global loader.
@Component({
  selector: 'csd-signin',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SigninComponent implements OnInit {
  private readonly oauthService = inject(OAuthService);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  ngOnInit(): void {
    void this.initializeAuthentication();
  }

  private async initializeAuthentication(): Promise<void> {
    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();

      if (this.oauthService.hasValidAccessToken()) {
        await this.router.navigate(['/dashboard']);
      } else {
        this.store.dispatch(AuthActions.loginInitiated());
        this.oauthService.initCodeFlow();
      }
    } catch {
      this.store.dispatch(AuthActions.loginInitiated());
      this.oauthService.initCodeFlow();
    }
  }
}
